.reactSwitchCheckbox {
  width: 0;
  height: 0;
  visibility: hidden;
  display: none;
}

.reactSwitchLabel {
  position: relative;
  display: flex;
  width: 32px;
  height: 21px;
  align-items: center;
  justify-content: space-between;
  border-radius: 100px;
  cursor: pointer;
  transition: background-color 0.25s;
  
  &.disabled {
    cursor: unset;
  }

  &.labelWithText {
    width: 47px;
    height: 24px;
    font-size: 8px;
    font-weight: 600;
    display: grid;
    grid-template-columns: 1fr 1fr;
    transition: background-color 0.1s;
    text-align: center;
    padding: 0 5px;
    box-sizing: border-box;

    > div{
      user-select: none;
    }

    .reactSwitchButton {
      width: 20px;
      height: 20px;
    }
  }

  .reactSwitchButton {
    position: absolute;
    top: 2px;
    left: 2px;
    display: flex;
    width: 17px;
    height: 17px;
    align-items: center;
    justify-content: center;
    border-radius: 45px;
    box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
    transition: 0.25s;
  }

  svg {
    width: 7px !important;
    height: 6px !important;
    margin-left: 1px;
    transform: scale(1.25);
    pointer-events: none;
  }
}

.checkBoxSwitchContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 300;
  width: fit-content;
  height: fit-content;
  
  &.disabled {
    pointer-events: none;
  }
}

.reactSwitchCheckbox:checked + .reactSwitchLabel .reactSwitchButton {
  left: calc(100% - 2px);
  transform: translateX(-100%);
}

.checkBoxSwitchContainer:active {
  .reactSwitchLabel .reactSwitchButton {
    width: 75%;
  }
}

.reactSwitchCheckbox:checked + .reactSwitchLabel {
  &.disabled {
    background-color: #afb8c0;

    .reactSwitchButton {
      background-color: #f5f6f8;
      
      svg {
        color: #afb8c0;
      }
    }
  }
}
